import { injectable } from "inversify";
import { Either } from "fp-ts/lib/Either";
import ErrorEntity from "../../entities/ErrorEntity";
import StablishmentRepository from "../../repositories/StablishmentRepository";
import StablishmentEntity from "../../entities/StablishmentEntity";

interface _Props {
    stablishmentRepository: StablishmentRepository;
}

@injectable()
export default class GetStablishmentByIdUseCase {
    private stablishmentRepository: StablishmentRepository;
    
    constructor(props: _Props) {
        this.stablishmentRepository = props.stablishmentRepository;
    }
    
    public call = async (id: string) : Promise<Either<ErrorEntity, StablishmentEntity>> => {
        return this.stablishmentRepository.getStablishmentById(id);
    }
}

export const GetStablishmentByIdUseCaseName = "GetStablishmentByIdUseCase";